import { RootState } from '@/App/store';

export const selectRefDataRefresh = (state: RootState) => state.refdata.refresh;
